import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ImageManager from 'MyAccount/AssetManager/ImageManager/ImageManager';
import { getSelectedImages, getCurrentFolderImages, createFilePathObject } from 'MyAccount/AssetManager/ImageManager/selectors';

@connect(
  state => {
    const selectedImages = getSelectedImages(state, 'Icons');
    const selected = _.keys(selectedImages);
    const images = [];
    if (!_.isEmpty(selected)) {
      _.map(selected, item => {
        const imagePathObj = createFilePathObject(item);
        const files = getCurrentFolderImages(state, {
          resourceType: 'Icons',
          currentFolder: state.images.Icons.selectedFolder,
        });
        const index = _.findIndex(files, (file) => file.name === imagePathObj.fileName);
        images.push(files[index]);
      });
    }
    return ({
      selectedFolder: state.images.Icons.selectedFolder,
      images,
      snackbarData: state.images.Images.snackbarData,
    });
  }
)

export default class ImageManagerWrap extends Component {
  state = {
    selectedImages: [],
  }

  componentWillReceiveProps(nextProps) {
    const { images } = this.props;
    if (images !== nextProps.images) {
      this.props.changeImages(nextProps.images);
      this.setState({ selectedImages: nextProps.images });
    }
  }

  render() {
    const { selectedFolder, snackbarData, ...otherProps } = this.props;
    let selectedImages = [];
    if (this.props.selectedImages) {
      selectedImages = this.props.selectedImages;
    } else {
      selectedImages = this.state.selectedImages;
    }
    return (
      <ImageManager
        currentFolder={selectedFolder}
        selectedImages={selectedImages}
        type="icons"
        integrated
        snackbarData={snackbarData}
        { ...otherProps }
      />
    );
  }
}
